var House = {
		 source:null,
	     mapButton : null
};﻿

var HouseResult = {
	map : false,
	isHouseListNotEmpty : false,
	centerLatLon : null
};